import React from "react";
import styles from "./WizardLayout.module.scss";
import classNames from "classnames";

const WizardLayout = ({children, className}) => {
    return <section className={classNames(styles.base, className)}>
        {children}
    </section>
}

export default WizardLayout;
